export const hideShopFor = [
  2019, 2003, 2001, 2000, 1982, 1953, 1943, 1941, 1921, 1914, 1882, 1855, 1852, 1796, 1790, 1701, 1697, 1688, 1681, 1652, 1568, 1464,
  1350,
];
export const showPromoFor = [1407, 1758, 1837, 1678, 1872, 1692, 2034, 2052, 2082, 1838, 2120, 1628, 2349,2358,1833,2319,2184,1692,1757,1035,1407,2226,1758,1678,2052,1902,2082,1775,1628,1838,2120,1709,1505,2338,2274,2276,2357];
